// extracted by mini-css-extract-plugin
export default {"link":"SwapTxHash_link__7R1BU","active":"SwapTxHash_active__P8WVE"};